<template>
  <div class="text-left" data-testid="upload-quality-warnings-step">
    <div class="border border-alert bg-orange-50 rounded-lg px-4 py-3">
      <p class="text-md font-bold text-textPrimary m-0" data-testid="upload-quality-warnings-title">
        {{ qualityWarningsTitle(messages.length) }}
      </p>
      <ul class="list-disc pl-5 mt-2 mb-0 text-sm text-textPrimary">
        <li v-for="(message, index) in messages" :key="index" data-testid="upload-quality-warning">
          {{ message }}
        </li>
      </ul>
    </div>

    <!--
      A folha JÁ está no servidor quando este painel aparece: a pré-validação roda no upload.
      Por isso "Concluir" é a ação normal e "Refazer a foto" é um novo envio, não um desfazer.
    -->
    <p class="text-xs text-neutral50 mt-3">
      O registro já foi enviado. "Refazer a foto" volta ao passo do arquivo para enviar uma versão
      melhor da mesma folha; "Concluir" mantém o que foi enviado.
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { qualityWarningsTitle, translateQualityWarnings } from './quality-warnings'

/**
 * Eixo 2B — painel de avisos de qualidade da imagem, exibido depois da resposta do upload.
 * Nunca bloqueia: sem `warnings` o componente não é montado pelo modal.
 */

const props = defineProps<{ warnings: string[] }>()

const messages = computed(() => translateQualityWarnings(props.warnings))
</script>
